import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import ArrowForwardSharpIcon from '@mui/icons-material/ArrowForwardSharp';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import "./ScrollDialog.css"
import { Typography } from '@mui/material';

ScrollDialog.propTypes = {
    versionInfo: PropTypes.any,
    aboutApp: PropTypes.any,
    title: PropTypes.string
}

const titleStyle = {color: '#050A44', fontWeight: '600', 'padding': '0px !important', '&:hover':{
  color: '#B3B4BD',
  backgroundColor: 'transparent'
}}

const titleStyleInner = {color: '#050A44', fontWeight: 'bold', backgroundColor: 'whitesmoke'
}


const DialogStyle = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
  borderRadius: '20px',
  },
  '& .MuiDialogContent-root': {
    backgroundColor: "whitesmoke",
  },
  '& .MuiDialogActions-root': {
    backgroundColor: "whitesmoke"
  }
}))

export default function ScrollDialog(props) {
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <React.Fragment>
      <Button endIcon={<ArrowForwardSharpIcon />} sx={titleStyle} onClick={handleClickOpen('paper')}>{props.title}</Button>
      <DialogStyle
        disableScrollLock
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle sx={titleStyleInner} id="scroll-dialog-title">{props.title}</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            className='dialogContent'
            component={'span'}
          >
           {props.versionInfo !== null && (Object.entries(props.versionInfo).map(([key, value]) =>{
            return(
            <div key={key}>
              <Button
                sx={{
                    color: 'violet',
                    padding: '8px 12px',
                    textTransform: 'none', // Prevents button text from being all caps
                }}
                className='oldButton'
                href={value[1]}
                startIcon={<CloudDownloadOutlinedIcon sx={{ fontSize: '2rem' }} />} // Icon on the left
              >
             
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start', 
                  marginLeft: '8px'
                }}>
                  <Typography sx={{ fontWeight: '600', lineHeight: '1.2' }}>
                      {key}
                  </Typography>
                  <Typography variant="caption" sx={{ display: 'block' }}>
                      {value[2]}
                  </Typography>
                </div>
              </Button> : <span>{value[0]}</span>
              <br />
            </div>
           )}))}

           <span>{props.aboutApp !== null && props.aboutApp}</span>
      
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{color: '#050A44'}} onClick={handleClose}>Close</Button>
        </DialogActions>
      </DialogStyle>
    </React.Fragment>
  );
}